// extracted by mini-css-extract-plugin
export default {"promoBarWrapper":"Banner-module--promoBarWrapper--edadd","button":"Banner-module--button--3c205"};